module.exports = __webpack_public_path__ + "img/gradient-11.aae49867.png";